export default "__VITE_ASSET__RxyaNmzu__"